import {createFileRoute} from '@tanstack/react-router';
import {BillPaymentOpenBankingCallbackPage} from 'features/bill-payment/pages/BillPaymentOpenBankingCallbackPage';
import {isPaymentMode} from 'features/shared/payment/types/PaymentMode';

export const Route = createFileRoute(
  '/_protected/bill-payment/$billId/callback/open-banking',
)({
  validateSearch: (search) => {
    return {
      paymentId: `${search.paymentId}`,
      paymentMode: isPaymentMode(search.paymentMode)
        ? search.paymentMode
        : 'openbanking_sessionless',
    } as const;
  },
  component: BillPaymentOpenBankingCallbackPage,
});
